<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-skeleton-loader type="heading" class="mb-4"></v-skeleton-loader>
        <v-skeleton-loader type="heading"></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-skeleton-loader max-width="300" type="card"></v-skeleton-loader>
        <v-skeleton-loader max-width="300" type="card"></v-skeleton-loader>
        <v-skeleton-loader max-width="300" type="card"></v-skeleton-loader>
      </v-col>
      <v-col cols="8" align="center" class="justify-center">
        <p class="mt-10">
          {{$i18n.t('LoadingPage.text')}}<br/>
          <spinner/>
        </p>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import { mapState } from 'vuex';
import ACTIONS from '../storeActions';
import BusinessLogicRunInfo from '../libs/businessLogicRunInfo';
import BusinessLogicAssessments from '../libs/businessLogicAssessments';
import BusinessLogicObservation from '../libs/businessLogicObservation';
import Spinner from './Spinner';

export default {
  name: 'Loader',
  components: {
    Spinner,
  },
  data: () => ({
  }),
  computed: {
    ...mapState([
      'runInfo',
    ]),
  },
  mounted() {
    // todo: Propably wait for all contents using promises
    const self = this;
    const blRunInfo = new BusinessLogicRunInfo(this, null, this.$store.state.user);
    const blAssessments = new BusinessLogicAssessments(this.$store, this.$apiRequest, this.$i18n);
    const blObservation = new BusinessLogicObservation(this);
    blRunInfo.loadRunInfo(this)
      // currently interviews are not impl.
      // .then(() => blRunInfo.loadInterviews())
      .then(() => blAssessments.loadAssessments())
      .then(() => blObservation.loadAllObservations())
      // handled differently
      //.then(() => blRunInfo.loadDocumentNames())
      // no participant image endpoint
      //.then(() => blRunInfo.loadAllParticipantImages(self))
      .then(() => {
        if (this.runInfo.status <= 0 || this.runInfo.status > 1) {
          self.$router.push('blocker');
        } else {
          self.$router.push('overview');
        }
      })
      .catch((e) => {
        console.log(e);
        self.$store.dispatch(ACTIONS.SET_SNACKBAR, { text: e.message, color: 'error' })
        self.$router.push('login');
      })
  },
};
</script>

<style scoped>

</style>
